define("shared/components/shared/ui/accordion-item", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/runloop", "@glimmer/component", "@glimmer/tracking", "later/utils/uuid"], function (_exports, _component, _templateFactory, _object, _runloop, _component2, _tracking, _uuid) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/uuid"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class={{this.classNames}}
    {{did-update (fn this.updateOpenItem @openItemId) @openItemId}}
    {{on "click" this.handleClick}}
    ...attributes
  >
    <div class="cPM--field__icon {{if @isDisabled 'is--disabled'}} {{if @appcuesClass @appcuesClass}}">
      {{svg-jar @icon class="o--icon"}}
    </div>
    <div
      class={{concat
        "cPM--field__content"
        (if @hasContent " has--content")
        (if @hasError " has--error")
        (if @hasWarning " has--warning")
        (if @hasWarningInside " has--warning--inside")
        (if @isDisabled " is--disabled")
        (if @isHighlighted " is--highlighted")
        (if @isLocked " is--locked")
        (if @isPosted " is--posted")
        (unless this.isOpen " is--closed")
      }}
    >
      <div class="cPM--field__composerHeader" {{on "click" this.toggleItem}}>
        {{yield (hash header=(component "shared/ui/block") isOpen=this.isOpen)}}
      </div>
      {{#unless @isDisabled}}
        <div class="cPM--field__composerBody {{if this.isOpen 'is--open' 'is--closed'}}">
          {{yield (hash body=(component "shared/ui/block" isOpen=this.isOpen) isOpen=this.isOpen)}}
        </div>
      {{/unless}}
    </div>
  </div>
  
  {{yield (hash footer=(component "shared/ui/block") isOpen=this.isOpen)}}
  */
  {
    "id": "CkvPpanA",
    "block": "[[[11,0],[16,0,[30,0,[\"classNames\"]]],[17,1],[4,[38,0],[[28,[37,1],[[30,0,[\"updateOpenItem\"]],[30,2]],null],[30,2]],null],[4,[38,2],[\"click\",[30,0,[\"handleClick\"]]],null],[12],[1,\"\\n  \"],[10,0],[15,0,[29,[\"cPM--field__icon \",[52,[30,3],\"is--disabled\"],\" \",[52,[30,4],[30,4]]]]],[12],[1,\"\\n    \"],[1,[28,[35,4],[[30,5]],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[15,0,[28,[37,5],[\"cPM--field__content\",[52,[30,6],\" has--content\"],[52,[30,7],\" has--error\"],[52,[30,8],\" has--warning\"],[52,[30,9],\" has--warning--inside\"],[52,[30,3],\" is--disabled\"],[52,[30,10],\" is--highlighted\"],[52,[30,11],\" is--locked\"],[52,[30,12],\" is--posted\"],[52,[51,[30,0,[\"isOpen\"]]],\" is--closed\"]],null]],[12],[1,\"\\n    \"],[11,0],[24,0,\"cPM--field__composerHeader\"],[4,[38,2],[\"click\",[30,0,[\"toggleItem\"]]],null],[12],[1,\"\\n      \"],[18,13,[[28,[37,8],null,[[\"header\",\"isOpen\"],[[50,\"shared/ui/block\",0,null,null],[30,0,[\"isOpen\"]]]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[51,[30,3]],[[[1,\"      \"],[10,0],[15,0,[29,[\"cPM--field__composerBody \",[52,[30,0,[\"isOpen\"]],\"is--open\",\"is--closed\"]]]],[12],[1,\"\\n        \"],[18,13,[[28,[37,8],null,[[\"body\",\"isOpen\"],[[50,\"shared/ui/block\",0,null,[[\"isOpen\"],[[30,0,[\"isOpen\"]]]]],[30,0,[\"isOpen\"]]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[18,13,[[28,[37,8],null,[[\"footer\",\"isOpen\"],[[50,\"shared/ui/block\",0,null,null],[30,0,[\"isOpen\"]]]]]]]],[\"&attrs\",\"@openItemId\",\"@isDisabled\",\"@appcuesClass\",\"@icon\",\"@hasContent\",\"@hasError\",\"@hasWarning\",\"@hasWarningInside\",\"@isHighlighted\",\"@isLocked\",\"@isPosted\",\"&default\"],false,[\"did-update\",\"fn\",\"on\",\"if\",\"svg-jar\",\"concat\",\"unless\",\"yield\",\"hash\",\"component\"]]",
    "moduleName": "shared/components/shared/ui/accordion-item.hbs",
    "isStrictMode": false
  });

  let AccordionItemComponent = (_class = class AccordionItemComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "isOpen", _descriptor, this);

      _defineProperty(this, "baseClass", 'cPM--field');

      _defineProperty(this, "itemId", (0, _uuid.default)());
    }

    get classNames() {
      return this.args.class ? `${this.baseClass} ${this.args.class}` : this.baseClass;
    }

    get canToggle() {
      return !this.args.isLocked && (!this.isOpen || !this.args.hasContent);
    }

    updateOpenItem(itemId) {
      if (this.args.hasContent) {
        return false;
      }

      if (this.isOpen && this.itemId !== itemId) {
        this.isOpen = false;
      }
    }

    handleClick() {
      this._handleClick();
    }

    toggleItem(event) {
      if (this.canToggle) {
        if (!this.isOpen) {
          this.args.trackOpenItem?.();
        }

        this.isOpen = !this.isOpen;
      }

      this._handleClick();

      if (this.args.autofocus) {
        (0, _runloop.schedule)('afterRender', () => {
          const element = event.target.closest(`.${this.baseClass}`);
          element?.querySelector(this.args.autofocus)?.focus();
        });
      }
    }

    _handleClick() {
      if (!this.args.isLocked && this.isOpen) {
        this.args.setOpenItem(this.itemId);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isOpen", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.args.hasContent;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "updateOpenItem", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateOpenItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleItem", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleItem"), _class.prototype)), _class);
  _exports.default = AccordionItemComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AccordionItemComponent);
});